"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        GState.bind(this, ['notification']);
        this.state.notification = this.state.notification.filter(each => {
            return !each.seen;
        });
    },
    onSeen: async function (index) {
        this.state.notification[index].seen = true;
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/NotificationLayout.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    NotificationCard_template = require("./NotificationCard.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    NotificationCard_tag = marko_loadTag(NotificationCard_template),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("da001c"),
    marko_node0 = marko_createElement("h5", null, "1", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("You've caught up!"),
    marko_attrs0 = {
        "class": "widget-timeline"
      };

function render(input, out, __component, component, state) {
  var data = input;

  if (!state.notification.length) {
    out.e("div", {
        "class": "placeholder w-100 text-center",
        style: marko_styleValue({
            padding: "5% 0"
          })
      }, "0", component, 1, 1)
      .n(marko_node0, component);
  } else {
    out.be("ul", marko_attrs0, "2", component);

    marko_forOf(state.notification, function(notifyset, index) {
      NotificationCard_tag(notifyset, out, __component, index, [
        [
          "seen",
          "onSeen",
          false,
          [
              index
            ]
        ]
      ]);
    });

    out.ee();
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
